<template>
  <div>
    <div class="cont-box">
      <div class="nav" style="margin:18px 0">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item style="font-size:18px">物资管理</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:18px">库存管理</el-breadcrumb-item>
      </el-breadcrumb>
      </div>
      <div class="scroll-big">
        <div class="tubiao">
          <div class="tubiao-l">
            <div class="tubiao-l-l" @click="goDown"></div>
            <div class="tubiao-l-r" @click="goUp"></div>
            <div class="dian" style="margin-left:27px">物资库存显示</div>
            <div id="echarts" class="echarts"></div>
            <!-- <el-carousel indicator-position="outside" @change="change">
              <el-carousel-item v-for="item in ['echarts','echarts1']" :key="item">
                <div :id="item" class="item"></div>
              </el-carousel-item>
            </el-carousel> -->
          </div>
          <div class="tubiao-r">
            <div class="dian">不合格率</div>
            <div v-show="dataList4.length===0" class="text1">暂无数据</div>
            <div class="tubiao-r-r">
              <div class="search-1">
                <el-select v-model="tMonth" placeholder="月" @change="changeD">
                  <el-option
                    label="1月"
                    value="01">
                  </el-option>
                  <el-option
                    label="2月"
                    value="02">
                  </el-option>
                  <el-option
                    label="3月"
                    value="03">
                  </el-option>
                  <el-option
                    label="4月"
                    value="04">
                  </el-option>
                  <el-option
                    label="5月"
                    value="05">
                  </el-option>
                  <el-option
                    label="6月"
                    value="06">
                  </el-option>
                  <el-option
                    label="7月"
                    value="07">
                  </el-option>
                  <el-option
                    label="8月"
                    value="08">
                  </el-option>
                  <el-option
                    label="9月"
                    value="09">
                  </el-option>
                  <el-option
                    label="10月"
                    value="10">
                  </el-option>
                  <el-option
                    label="11月"
                    value="11">
                  </el-option>
                  <el-option
                    label="12月"
                    value="12">
                  </el-option>
                </el-select>
              </div>
              <span>数据</span>
            </div>
            <div id="echarts2" class="echarts2"></div>
          </div>
        </div>
        <div class="table-box">
          <div class="nav-bar">
            <div class="search">
              <el-input size="small" clearable @change="select" v-model="search.materialName" placeholder="请输入材料名称" style="margin: 0 10px;"></el-input>
              <el-button size="mini" type="primary" @click="select">查询</el-button>
            </div>
            <div class="btns">
              <!-- <div class="btn">导出表单</div>
              <div class="btn">入库记录</div>
              <div class="btn">单号录入</div>
              <div class="btn">批量录入</div> -->
              <!-- <el-button size="mini" type="primary">导出表单</el-button> -->
              <!-- <el-select v-model="isOpen" @change="changeState">
                <el-option label="开启" value="1"></el-option>
                <el-option label="不开启" value="0"></el-option>
              </el-select> -->
              <el-button size="mini" type="primary" @click="offOn">物料申请入库配置</el-button>
              <el-button size="mini" type="primary" @click="toStorageRecord">入库记录</el-button>
              <el-button size="mini" type="primary" @click="oddDialog = true">单号录入</el-button>
              <el-button size="mini" type="primary" @click="batchDialog = true">批量录入</el-button>
            </div>
          </div>
          <div class="title">库 存 详 情</div>
          <div class="table">
            <!-- <div class="table-title">
              <div class="text" style="max-width:70px;">序号</div>
              <div class="text" style="max-width:140px;">采购单号</div>
              <div class="text" style="max-width:160px;">材料类型</div>
              <div class="text" style="max-width:170px;">材料名称</div>
              <div class="text" style="max-width:170px;">材料型号</div>
              <div class="text" style="max-width:160px;">材料品牌</div>
              <div class="text" style="max-width:140px;">单价</div>
              <div class="text" style="max-width:220px;">生产厂家</div>
              <div class="text" style="max-width:220px;">供应商</div>
              <div class="text" style="max-width:140px;">库存数量</div>
              <div class="text" style="max-width:140px;">入库时间</div>
              <div class="text" style="max-width:140px;">操作</div>
            </div>
            <div class="table-cont">
              <div class="row">
                <div class="item" style="max-width:70px;">1</div>
                <div class="item" style="max-width:140px;">MT92648538</div>
                <div class="item" style="max-width:160px;">钢筋</div>
                <div class="item" style="max-width:170px;">8号钢筋</div>
                <div class="item" style="max-width:170px;">123456</div>
                <div class="item" style="max-width:160px;">海英钢铁</div>
                <div class="item" style="max-width:140px;">100.00</div>
                <div class="item" style="max-width:220px;">山东海英钢铁有限公司</div>
                <div class="item" style="max-width:220px;">安徽瞳声科技有限公司</div>
                <div class="item" style="max-width:140px;">500.00吨</div>
                <div class="item" style="max-width:140px;">2022-01-01 00:00:00</div>
                <div class="item" style="max-width:140px;">
                  <div class="chuku">
                    出库
                  </div>
                </div>
              </div>
              <div class="row"></div>
            </div> -->
            <el-table :data="tableData" stripe height="66vh">
              <el-table-column label="序号">
                <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
              <el-table-column label="材料类型">
                <template slot-scope="scope">
                    <span>{{ scope.row.materialTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="材料名称">
                <template slot-scope="scope">
                    <span>{{ scope.row.materialName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="材料品牌">
                <template slot-scope="scope">
                    <span>{{ scope.row.materialBrand }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单价(元)">
                <template slot-scope="scope">
                    <span>{{ scope.row.unitPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="库存数量">
                <template slot-scope="scope">
                    <span>{{ scope.row.amount }}{{ scope.row.materialUnitTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="生产厂家">
                <template slot-scope="scope">
                    <span>{{ scope.row.materialManufacturer }}</span>
                </template>
              </el-table-column>
              <el-table-column label="供应商">
                <template slot-scope="scope">
                    <span>{{ scope.row.materialSupplier }}</span>
                </template>
              </el-table-column>
              
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="out(scope.row)">出库</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fenye">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="20"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 批量弹出框 -->
    <el-dialog
      :visible.sync="batchDialog"
      center
      top="8vh"
      width="98%">
      <div class="dialog">
        <div class="dialog-left">
          <div class="dialog-search">
            <el-input v-model="search1.materialName" size="small" placeholder="请输入材料名称" clearable></el-input>
            <el-input v-model="search1.materialSupplier" size="small" placeholder="请输入供应商名称" clearable style="margin: 0 1vw;"></el-input>
            <el-button size="small" type="primary" @click="select2">查询</el-button>
          </div>
          <div class="dialog-table">
            <div class="title">供应商库物料列表</div>
            <el-table :data="supplierList" stripe height="60vh">
               <el-table-column label="序号">
                 <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                 </template>
               </el-table-column>
                <el-table-column label="材料名称">
                 <template slot-scope="scope">
                    <span>{{ scope.row.materialName }}</span>
                 </template>
               </el-table-column>
                <el-table-column label="材料型号">
                 <template slot-scope="scope">
                    <span>{{ scope.row.materialModel }}</span>
                 </template>
               </el-table-column>
                <el-table-column label="材料品牌">
                 <template slot-scope="scope">
                    <span>{{ scope.row.materialBrand }}</span>
                 </template>
               </el-table-column>
                <el-table-column label="供应商名称">
                 <template slot-scope="scope">
                    <span>{{ scope.row.materialSupplier }}</span>
                 </template>
               </el-table-column>
                <el-table-column label="操作">
                 <template slot-scope="scope">
                   <el-button size="mini" type="primary" @click="add(scope.row)">添加</el-button>
                 </template>
               </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="1"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="20"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total2">
            </el-pagination>
          </div>
        </div>
        <div class="dialog-right">
          <div class="title">添加列表</div>
          <el-table height="71vh" stripe :data="addList">
             <el-table-column label="序号" width="80" type="index" :index="1">
              </el-table-column>
              <el-table-column label="材料名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="材料型号">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialModel }}</span>
                </template>
              </el-table-column>
              <el-table-column label="材料品牌">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialBrand }}</span>
                </template>
              </el-table-column>
              <el-table-column label="供应商名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialSupplier }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单价(元)">
                <template slot-scope="scope">
                  <span>{{ scope.row.unitPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                   <el-input v-model="scope.row.amount" size="small" onkeyup="value=value.replace(/\D/g,'')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)" style="border-radius: 6px;">删除</el-button>
                </template>
              </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 自动出库开关 -->
    <el-dialog
    top="30vh"
      :visible.sync="dialogOff"
      width="30%"
      :before-close="handleClose">
      <div class="box">
        <div class="box-title">自动出库开关</div>
        <el-select v-model="isOpen" placeholder="请选择">
        <el-option
          label="开启"
          value="1">
        </el-option>
        <el-option
          label="不开启"
          value="0">
        </el-option>
      </el-select>
      </div>
      <div class="btn_ss">
        <el-button size="mini" @click="dialogOff = false">取 消</el-button>
        <el-button style="margin-left:2vw" size="mini" type="primary" @click="changeState">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 单号弹出框 -->
    <el-dialog
    :visible.sync="oddDialog"
    center
    top="8vh"
    width="98%"
    >
      <div class="dialog-search">
        <el-input size="small" v-model="search3.orderNumber" placeholder="请输入订单编号" clearable style="margin-right: 1vw;width: 220px;"></el-input>
        <el-button size="small" type="primary" @click="select3">查询</el-button>
      </div>
      <el-table stripe height="70vh" :data="oddNumberData">
        <el-table-column label="序号" type="index" :index="1" width="80"></el-table-column>
        <el-table-column label="材料类型">
          <template slot-scope="scope">
            <span>{{getMaterialType(scope.row.material_type)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="材料名称">
          <template slot-scope="scope">
            <span>{{scope.row.materialName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="材料型号">
          <template slot-scope="scope">
            <span>{{scope.row.materialModel}}</span>
          </template>
        </el-table-column>
        <el-table-column label="材料品牌">
          <template slot-scope="scope">
            <span>{{scope.row.materialBrand}}</span>
          </template>
        </el-table-column>
        <el-table-column label="生产厂家">
          <template slot-scope="scope">
            <span>{{scope.row.materialManufacturer}}</span>
          </template>
        </el-table-column>
        <el-table-column label="供应商">
          <template slot-scope="scope">
            <span>{{scope.row.materialSupplier}}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="scope">
            <span>{{scope.row.materialUnitTypeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="入库数量">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.amount" onkeyup="value=value.replace(/\D/g,'')"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="oddDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

       <span slot="footer" class="dialog-footer">
        <el-button @click="oddDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitOddNumber">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 材料出库弹出框 -->
    <el-dialog
      :visible.sync="deliveryDialog"
      center
      width="25%"
    >
      <div style="font-size: 20px;text-align: center;padding: 10px;font-weight: 900;">材料出库</div>
      <div style="padding: 20px">
        <p class="out-item">
          <span>材料类型</span>：
          <el-input size="small" v-model="outObj.materialTypeName" disabled></el-input>
        </p>
        <p class="out-item">
          <span>材料名称</span>：
          <el-input size="small" v-model="outObj.materialName" disabled></el-input>
        </p>
        <p class="out-item">
          <span>材料型号</span>：
          <el-input size="small" v-model="outObj.materialModel" disabled></el-input>
        </p>
        <p class="out-item">
          <span>材料品牌</span>：
          <el-input size="small" v-model="outObj.materialBrand" disabled></el-input>
        </p>
        <p class="out-item">
          <span>生产厂家</span>：
          <el-input size="small" v-model="outObj.materialManufacturer" disabled></el-input>
        </p>
        <p class="out-item">
          <span>供应商</span>：
          <el-input size="small" v-model="outObj.materialSupplier" disabled></el-input>
        </p>
        <p class="out-item">
          <span>出库数量</span>：
          <el-input size="small" v-model="amount"></el-input>
        </p>
        <p class="out-item">
          <span>单位</span>：
          <el-input size="small" v-model="outObj.materialUnitTypeName" disabled></el-input>
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="deliveryDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitDelivery">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import util from '../../../untils/util'
  import myHttp from '../../../untils/port'
  export default {
    mounted(){
      this.mapFn()
      this.mapFn1()
    },
    data() {
      return {
        dialogOff:false,
        isOpen: 0,
        batchDialog: false,   // 批量弹出框
        oddDialog: false,     // 单号弹出框
        deliveryDialog: false,   // 出库弹出框 
        projectId: '',
        search: {
          materialName: '',   //材料名称
        },
        search1: {
          materialName: '',
          materialSupplier: ''
        },
        search3: {
          orderNumber: ''    //单号   单号录入
        },
        tableData: [],
        supplierList: [],
        addList: [],
        oddNumberData: [],  // 单号数据
        typeList: [],  //材料类型
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pageSize2: 20,
        pageNum2: 1,
        total2: 0,
        outObj: {},
        inventoryId: '',   //库存id
        amount: '',    //数量 
        pageSizeA:15,
        pageNumA:1,
        dataList1:[],
        dataList2:[],
        dataList3:[],
        dataList4:[],
        dataList5:[],
        indexA:0,
        indexB:0,
        month:'',
        tYear:'',
        tMonth:'',
        length:0
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      var tMonth = myDate.getMonth();
      this.tMonth = tMonth
      this.tYear = tYear
      if(tMonth<10){
        this.tMonth = '0'+(tMonth+1)
      }
      this.getData()
      this.getSupplier()
      this.getType()
      this.getDataList()
      this.getDataList1()
      this.getConfig()
    },
    methods: {
      offOn(){
        this.dialogOff = true
      },
       getConfig(){
        myHttp.findProjectPurchaseConfig({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            console.log(resp.data.data.config.isOpen);
            if(resp.data.data.config.isOpen == 0){
              this.isOpen = '0'
            }else if(resp.data.data.config.isOpen == 1){
              this.isOpen = '1'
            }
          }else{
            this.$message({
              type: 'error',
              showClose: true,
              message: resp.data.msg
            })
          }
        })
      },
      changeState(){
        
        myHttp.configProjectPurchase({
          projectId: this.projectId,
          isOpen: this.isOpen
        }).then(resp => {
          if(resp.data.code === 200){
            this.dialogOff = false
              this.$message({
              type: 'success',
              showClose: true,
              message: '配置成功！！'
            })
          }else{
            this.$message({
              type: 'error',
              showClose: true,
              message: resp.data.msg
            })
          }
        })
      },
      // changeState(){
      //   myHttp.configProjectPurchase({
      //     projectId: this.projectId,
      //     isOpen: this.isOpen
      //   }).then(resp => {
      //     if(resp.data.code === 200){
      //         this.$message({
      //         type: 'success',
      //         showClose: true,
      //         message: '配置成功！！'
      //       })
      //     }else{
      //       this.$message({
      //         type: 'error',
      //         showClose: true,
      //         message: resp.data.msg
      //       })
      //     }
      //   })
      // },
      goUp(){
        if(this.length.length!==0){
          if(this.pageNumA!==this.length.length){
            ++this.pageNumA
            this.indexA =0
            this.getDataList()
          }
        }
      },
      goDown(){
        --this.pageNumA
        if(this.pageNumA!==0){
          this.indexA =0
          this.getDataList()
        }else{
          this.pageNumA=1
          this.indexA =0
        }
      },
      changeD(){
        this.getDataList1()
      },
      mapFn() {
        let that = this
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(
        document.getElementById("echarts")
      );
      document.getElementById("echarts").removeAttribute("_echarts_instance_");
      mapChart.setOption({
        grid:{
          top:30
        },
        xAxis: {
          type: 'category',
         //坐标轴斜着显示
          axisLabel: {  
           interval:0,  
           rotate:40  
       },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
          type: "category",
          data: that.dataList1,
        },
        yAxis: {
          min: 0, // 刻度最小值
          // max: 200, // 刻度最大值（需要动态获取最大值,并且能被3整除（向下取整再乘回来））
          splitNumber: 4, // 横线数
          // interval: 50,
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
        },
        series: [
          {
            barWidth: 20,
            data: that.dataList2,
            type: "bar",
            itemStyle: {
              normal: {
                color: function (params) {
                  // 给出颜色组
                  var colorList = [
                    "#0263ff",
                    "#34a1f7",
                    "#87bfed",
                    "#b4d5f1",
                    "#4a86b6",
                    "#2382cc",
                  ];
                  //循环调用
                  return colorList[params.dataIndex % colorList.length];
                },
                label: {
                  formatter: function(params){
                    that.indexA++
                    return params.value+that.dataList3[that.indexA-1]
                  },
                  show: true,
                  position: "top",
                  textStyle: {
                    fontWeight: "",
                    fontSize: "14",
                    color: "#333333",
                  },
                },
              },
            },
          },
        ],
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
      },
      mapFn1() {
        let that = this
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart1 = this.$echarts.init(
        document.getElementById("echarts2")
      );
      document.getElementById("echarts2").removeAttribute("_echarts_instance_");
      mapChart1.setOption({
        color:['#0263FF','#3582FF','#71A7FF','#9AC1FF','#B3D0FF','#E5EFFF','#5999FF','#71A7FF','#9AC1FF'],
        tooltip: {
          formatter:function(params){
            console.log(params)
            let str =`名称：${that.dataList5[params.dataIndex].materialName}</br>
                      总数量：${that.dataList5[params.dataIndex].allCount}</br>
                      不合格数量：${that.dataList5[params.dataIndex].disqualification}`
            return str
            
          }
        },
  series: [
    {
      type: 'pie',
      radius: ['5%', '90%'],
      avoidLabelOverlap: false,
      label: {
              show: true,
              position: "inner",
              formatter: "{b}",
            },
      labelLine: {
        show: true
      },
      data: that.dataList4
    }
  ]
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart1.resize();
        });
      },
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      select2(){
        this.pageSize2 = 20
        this.pageNum2 = 1
        this.getSupplier()
      },
      handleSizeChange2(val) {
        this.pageSize2 = val
        this.getSupplier()
      },
      handleCurrentChange2(val) {
        this.pageNum2 = val
        this.getSupplier()
      },
      change(index){
        console.log(index)
      },
      getDataList1(){
        myHttp.findMaterialEnteringDisqualificationStatistics({
          projectId:this.projectId,
          month:this.tYear+'-'+this.tMonth
        }).then(res=>{
          console.log(res,'99999999999999')
          if(res.data.code===200){
            this.dataList4 = []
            this.dataList5 = []
            res.data.data.materialEnteringDisqualificationStatistics.forEach((item,index)=>{
              this.dataList4.push({value:item.disqualificationRate,name:item.materialName})
              this.dataList5.push(item)
            })
            this.mapFn1()
          }
        })
      },
      // 获取图表数据
      getDataList(){
        myHttp.findProjectSupplierInverntoryPage({
          pageNum:this.pageNumA,
          pageSize:this.pageSizeA,
          projectId:this.projectId
        }).then(res=>{
          console.log(res,'99999999')
          if(res.data.code===200){
            this.dataList1 = []
              this.dataList2 = []
              this.dataList3 = []
            this.length = res.data.data.projectSupplierInverntoryPage.navigatepageNums
            res.data.data.projectSupplierInverntoryPage.list.forEach((item,index)=>{
              this.dataList1.push(item.materialName)
              this.dataList2.push(item.amount)
              this.dataList3.push(item.materialUnitTypeName)
            })
            this.mapFn()
          }
        })
      },
      // 获取数据
      getData(){
        myHttp.findProjectSupplierInverntoryPage({
          materialName: this.search.materialName,
          materialType: '',
          materialBrand: '',
          materialManufacturer: '',
          materialSupplier: '',
          materialUnitType: '',
          materialModel: '',
          projectId: this.projectId,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(resp => {
          if(resp.data.code === 200){
            const list = resp.data.data.projectSupplierInverntoryPage.list || []
            for(let i=0;i<list.length;i++){
              list[i].index = (this.pageNum - 1) * this.pageSize + 1 + i
            }
            this.tableData = list
            this.total = resp.data.data.projectSupplierInverntoryPage.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      //  获取供应商列表
      getSupplier(){
        this.search1.projectId = this.projectId
        this.search1.pageNum = this.pageNum2
        this.search1.pageSize = this.pageSize2
        myHttp.getProProjectSupplierPage(this.search1).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const list = resp.data.data.pageInfo.list || []
            list.forEach((item, index) => {
              item.index = (this.pageNum2 - 1) * this.pageSize2 + 1 + index
            })
            this.supplierList = list
            this.total2 = resp.data.data.pageInfo.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 单号录入查询
      select3(){
        myHttp.findPurchasePlanSupplierList({
          projectId: this.projectId,
          orderNumber: this.search3.orderNumber
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            this.oddNumberData = resp.data.data.purchasePlanSuppliers || []
          }else{
            this.$message.error(resp.data.msg)
            this.oddNumberData = []
          }
        })
      },
      // 删除单号录入的数据
      oddDelete(row){
        for(let i=0; i<this.oddNumberData.length;i++){
          if(this.oddNumberData[i].supplierId == row.supplierId){
            this.oddNumberData.splice(i, 1)
          }
        }
      },
      // 提交单号录入
      submitOddNumber(){
        let obj = {}
        let purchaseSupplierPlanVos = []
        this.oddNumberData.forEach(item => {
          obj.supplierId = item.supplierId
          obj.amount = item.amount
          purchaseSupplierPlanVos.push(JSON.parse(JSON.stringify(obj)))
        })
        myHttp.orderEntryProjectSupplier({
          projectId: this.projectId,
          orderNumber: this.search3.orderNumber,
          purchaseSupplierPlanVos
        }).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('录入成功！！'),
            this.oddDialog = false
            this.getData()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 添加
      add(row){
        console.log(row);
        if(this.addList.length){
          let ids = []
          this.addList.forEach(item => {
            ids.push(item.id)
          })
          if(!ids.includes(row.id)){
            this.addList.push(row)
          }
        }else{
          this.addList.push(row)
        }
      },
      // 提交
      submitBatch(){
        const purchaseSupplierPlanVos = []
        this.addList.forEach(item => {
          let obj = {}
          obj.supplierId  = item.id
          obj.amount = item.amount
          purchaseSupplierPlanVos.push(obj)
        })
        myHttp.manuallyProjectSupplier({
          projectId: this.projectId,
          purchaseSupplierPlanVos
        }).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('录入成功！！')
            this.batchDialog = false
            this.addList = []
            this.getData()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 打开出库弹出框
      out(row){
        this.deliveryDialog = true
        this.amount = ''
        this.inventoryId = row.inventoryId
        this.outObj = row
      },
      // 提交出库
      submitDelivery(){
        myHttp.deliveryStorage({
          inventoryId: this.inventoryId,
          amount: this.amount
        }).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('出库成功！！')
            this.deliveryDialog = false
            this.getData()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 删除
      handleDelete(row){
        for(let i=0;i<this.addList.length;i++){
          if(row.id == this.addList[i].id){
            this.addList.splice(i, 1)
          }
        }
      },
      //  获取材料类型
      getType(){
        myHttp.getDictByType({
          type: 'material_type'
        }).then(resp => {
           if(resp.data.code === 200){
             this.typeList = resp.data.data.dictList || []
           }else{
             this.$message.error(resp.data.msg)
           }
        })
      },
      getMaterialType(type){
        for(let i=0;i<this.typeList.length;i++){
          if(type == this.typeList[i].value){
            return this.typeList[i].label
          }
        }
      },
      // 去入库记录页面
      toStorageRecord(){
        this.$router.push({
          path: '/storageRecord'
        })
      }
    },
  }
</script>

<style scoped>
.cont-box{
  width: 100%;
  height: 90.6vh;
  background-color: #F3F8FC;
  padding-left: 8px;
  padding-right: 12px;
  display:inline-block;
}
.tubiao{
  display: flex;
  justify-content: space-between;
}
.tubiao-l{
  width: 64.3vw;
  height: 37vh;
  background-color: #fff;
  box-shadow: 2px 2px 7px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  position: relative;
  overflow: hidden;
}
.tubiao-l-l{
  position: absolute;
  left: 0;top: 0;
  width: 3%;
  background-color: #e6e6e6;
  height: 100%;
  /* display: flex;align-items: center;
  justify-content: center; */
  background: url('../../../assets/image/箭头左.png') no-repeat #e6e6e6;
  background-position:left 30% top 46%;
  z-index: 100;
}
.tubiao-l-l:hover{
  cursor: pointer;
  opacity: 0.8;
  background: url('../../../assets/image/箭头 左.png') no-repeat #e6e6e6;
  background-position:left 30% top 46%;
}
.tubiao-l-r{
  position: absolute;
  right: 0;top: 0;
  width: 3%;
  background-color: #e6e6e6;
  height: 100%;
  /* display: flex;align-items: center;
  justify-content: center; */
  background: url('../../../assets/image/箭头 右.png') no-repeat #e6e6e6;
  background-position:right 30% top 46%;
  z-index: 100;
}
.tubiao-l-r:hover{
  cursor: pointer;
  opacity: 0.8;
  background: url('../../../assets/image/箭头 右 (1).png') no-repeat #e6e6e6;
  background-position:right 30% top 46%;
}
.tubiao-r{
  width: 23.8vw;
  height: 37vh;
  background-color: #fff;
  box-shadow: 2px 2px 7px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  position: relative;
}
.tubiao-r-r{
  width: 120px;
  height: 35px;
  position: absolute;
  right: 30px;top: 16px;
  display: flex;
  align-items: center;
}
.search-1{
  width: 70px;
}
.scroll-big{
  height: 83.5vh;
  overflow: scroll;
}
.scroll-big::-webkit-scrollbar{
  height: 0;
  width: 0px;
}
.table-box{
  margin-top: 5px;
  height: 83.5vh;
  background-color: #fff;
  box-shadow: 2px 2px 7px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
}
.title{
  height: 60px;
  background-color: #e6e6e6;
  font-weight: 900;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-bar{
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
}
.btns{
  width: 40%;
  display: flex;
  justify-content: flex-end;
}
.btns > div{
  margin-left: 10px;
}
.btn:hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn{
  width: 90px;
  height: 30px;
  line-height:30px;
  color: #fff;
  background-color: #0b62f0;
  border-radius: 6px;
  font-size: 16px;
}
.el-button--primary{
  background-color: #0b62f0;
  border-radius: 6px;
}
.table{
  overflow-y: hidden;
  overflow-x: auto;
}
.table-title{
  width: 1900px;
  display: flex;
}
.table-title{
  border-bottom: 2px solid #e7e7e7;
}
/* .text{
  height: 60px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
} */
.text1{
  position:absolute;
  left: 191px;
  top: 156px;
  z-index: 999;
}
.table-cont{
  width: 1900px;
  height: 58vh;
}
.fenye{
  background-color: #eee;
  height: 47px;
}
.row{
  border-bottom: 2px solid #e7e7e7;
  height: 60px;
  display: flex;
  
  align-items: center;
}
.row:last-child{
  border-bottom: none;
}
.item{
  flex: 1;
  display: flex;
  justify-content: center;
}
.chuku{
  font-size: 15px;
  width: 60px;
  height: 30px;
  color: #fff;
  background-color: #0b62f0;
  line-height: 30px;
  border-radius: 6px;
}
.chuku:hover{
  cursor: pointer;
  opacity: 0.7;
}
.dian{
  padding-left:56px ;
  height: 60px;
  line-height: 60px;
  font-family: PingFang-SC-Bold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  text-align: start;
  position: relative;
}

.dian::after{
  position: absolute;
  left: 28px;
  top: 23px;
  content: "";
  width: 15px;
	height: 16px;
	background-color: #0b62f0;
  border-radius: 50%;
}
.echarts{
  width: 1235px;
  height: 285px;
}
.echarts1{
  width: 1235px;
  height: 285px;
}
.echarts2{
  width: 23.8vw;
  height: 285px;
}
.el-pagination{
  text-align: center;
  background-color: #eee;
  border-radius: 0 0 6px 6px;
}
.search{
  display: flex;
  width: 50%;
}
.el-input--small{
  width: 150px;
}
.dialog{
  height: 78vh;
  display: flex;
}
.dialog-left{
  width: 45%;
  height: 100%;
  box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
}
.dialog-right{
  width: 53%;
  height: 100%;
  box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.5);
  margin-left: 2%;
  border-radius: 6px;
}
.dialog-search{
  padding: 10px;
  display: flex;
}
.dialog-search >>> .el-input{
  width: 150px;
}
.out-item{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.out-item > span {
  width: 6vw;
  text-align-last: justify;
}
.out-item >>> .el-input--small{
  width: 13vw;
}
.el-button--text{
  color: #D25B45;
}

/deep/ .el-dialog__headerbtn{
  display: none;
}
/deep/ .el-dialog__header{
  padding: 0;
}
/deep/ .el-dialog__body{
  padding: 10px;
}
.box>.box-title{
  font-size: 15px;
  margin-right: 2%;
}
.box{
  height: 20vh;
  display: flex;
  padding-left: 18%;
  justify-content: start;
  align-items: center;
}
</style>